import { ObjectExt } from '../../util';
export const style = {
  qualify: ObjectExt.isPlainObject,
  set(styles, _ref) {
    let view = _ref.view,
      elem = _ref.elem;
    view.$(elem).css(styles);
  }
};